"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncBaseLanguageSettingsContainer = AsyncBaseLanguageSettingsContainer;
exports.AsyncSitemapsSettingsContainer = AsyncSitemapsSettingsContainer;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var BaseLanguageSettingsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/BaseLanguageSettingsContainer'
    /* webpackChunkName: "chunk-marketing-domains" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncBaseLanguageSettingsContainer(props) {
  return _react.default.createElement(BaseLanguageSettingsContainer, props);
}

var SitemapsSettingsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/sitemaps/SitemapsSettingsContainer'
    /* webpackChunkName: "chunk-marketing-domains" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncSitemapsSettingsContainer(props) {
  return _react.default.createElement(SitemapsSettingsContainer, props);
}